import { render, staticRenderFns } from "./YZQuery.vue?vue&type=template&id=0983b7db&"
import script from "./YZQuery.vue?vue&type=script&lang=js&"
export * from "./YZQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports